import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';

import SaleFooter from '../SaleFooter/SaleFooter';
import {showAppLoader, hideAppLoader} from '../../../Shared/Loader/LoaderSlice';
import ProviderManager from '../../../../provider/providerManager';
import Config from '../../../../Config';
import {getRecaptchaToken} from '../../../../utilities/recaptcha/recaptcha';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import {
  goToPage,
  setSaleDetails,
  reportAnalytics,
  setIsSubmit,
  setIsValid,
  setOtpCode,
  setWrongOtpMessage,
  setSelectedInternetPackage,
  saveBaseBezeqFiberProduct,
  addAttempt,
  setError,
} from '../saleBlockSlice';
import OTPVerifyCode from '../OTPVerifyCode/OTPVerifyCode';
import loginSubTypes from '../../../../constans/loginSubTypes';

const OtpVerifyCodePage = (props) => {
  let saleType = props.saleType;
  let flowType = props.flowType;

  useEffect(() => {
    let eventLabel = props.productsInfo.selectedProducts ? props.productsInfo.selectedProducts[0]?.name : '';
    switch (saleType) {
      case 'tv':
        props.reportAnalytics({eventCategory: 'tv_newsale_process', eventAction: 'visibility_21', eventLabel: eventLabel});
        break;
      case 'app':
        props.reportAnalytics({eventCategory: 'app_newsale_process', eventAction: 'visibility_29', eventLabel: eventLabel});
        break;
      case 'cellular':
        props.reportAnalytics({eventCategory: 'cellular_newsale_process', eventAction: 'visibility_24', eventLabel: 'screen_14'});
        break;
      case 'internet':
        props.reportAnalytics({eventCategory: 'fiber_newsale_process', eventAction: 'visibility_17', eventLabel: eventLabel});
        break;
    }
  }, []);

  useExtendedEffect((runSideEffects) => {
    if (!runSideEffects()) {
      window.history.go(-1);
    }
  }, []);

  //page params
  let isDisplayFooter = true;
  let btnText = 'אישור וממשיכים';
  let currentPageFunction = handleOtpVerifyCodePageContinue;
  let totalPrice = null;
  let priceText = 'לחודש';
  let formid = 'sale';
  //page params

  let currentPageHeadline = (
    <div className='page-headline-wrapper'>
      <h1 className='sale-title'> {props.configuration.welcomeText} </h1>
      <h1 className='sale-title-big'> שלחנו קוד אימות, הגיע? </h1>
      <h2 className='sale-title-small'> הקלידו את הקוד ששלחנו לנייד </h2>
    </div>
  );

  let currentPageView = (
    <OTPVerifyCode onValid={handleOTPVerifyCodeValidate} onSubmit={props.isSubmit} wrongOtpMessage={props.wrongOtpMessage} />
  );

  function handleOtpVerifyCodePageContinue() {
    if (props.numOfAttempts >= Config.verifyCodeAttemptsLimit) {
      props.setWrongOtpMessage({wrongOtpMessage: 'עברת את מספר הנסיונות המותר'});
      return;
    }

    props.setIsSubmit({isSubmit: true});
  }

  function handleOTPVerifyCodeValidate(valid) {
    if (valid) {
      handleOtpVerifyCodePageContinueAfterValid();
    }
    props.setIsSubmit({isSubmit: false});
  }

  async function handleOtpVerifyCodePageContinueAfterValid() {
    const eventLabel = props.productsInfo.selectedProducts[0]?.name;

    switch (saleType) {
      case 'tv':
        props.reportAnalytics({eventCategory: 'tv_newsale_process', eventAction: 'click_31', eventLabel: eventLabel});
        break;
      case 'app':
        props.reportAnalytics({eventCategory: 'app_newsale_process', eventAction: 'click_41', eventLabel: eventLabel});
        break;
      case 'cellular':
        props.reportAnalytics({eventCategory: 'cellular_newsale_process', eventAction: 'click_47', eventLabel: 'button_14'});
        break;
      case 'internet':
        props.reportAnalytics({eventCategory: 'fiber_newsale_process', eventAction: 'click_23', eventLabel: eventLabel});
        break;
    }

    const isValidOtp = await validateOtp();
    if (!isValidOtp) {
      props.addAttempt();
      props.setWrongOtpMessage({wrongOtpMessage: 'הקוד שהוזן אינו תקין, נסה שנית'});
      return;
    }

    let saleDetails = {};

    if (saleType != 'cellular') {
      saleDetails = await getSaleDetails();
      props.setSaleDetails(saleDetails);

      if (saleDetails?.isJetCustomer) {
        props.setError({isDisplay: true, id: 64, isOpenWorkOrder: true});
        return;
      }
    }

    props.setOtpCode({otpCode: props._otpCode});
    props.setWrongOtpMessage({wrongOtpMessage: ''});

    switch (saleType) {
      case 'tv':
        if (flowType == 'existsCustomer' || props.isOtherAddress || props.isSkipToNewCustomer) {
          props.goToPage({page: 'summaryPage', percent: 72});
        } else {
          props.goToPage({page: 'personalInfoPage', percent: 63});
        }
        break;
      case 'app':
        if (flowType == 'existsCustomer' || props.isOtherAddress || props.isSkipToNewCustomer) {
          props.goToPage({page: 'summaryPage', percent: 70});
        } else {
          props.goToPage({page: 'personalInfoPage', percent: 56});
        }
        break;
      case 'cellular':
        if (flowType == 'existsCustomer' || props.isOtherAddress || props.isSkipToNewCustomer) {
          props.goToPage({page: 'summaryPage', percent: 80});
        } else {
          props.goToPage({page: 'personalInfoPage', percent: 70});
        }
        break;
      case 'internet':
        getNextPage(saleDetails);
        break;
    }
  }

  async function getNextPage(saleDetails) {
    const idNumber = props.otpIdentity;
    const otpTicketId = props.otpTicketId;
    const otpPhone = props.otpPhone;

    const customerBanPsidList = saleDetails?.customerBanPsidList;

    const packageType = props.packageType; // none | open | closed
    let isAllowSale = true;

    let allProducts = [];
    if (customerBanPsidList != null && customerBanPsidList.length > 0) {
      customerBanPsidList.map((data, index) => {
        if (data.brbType.toUpperCase() == 'T') {
          isAllowSale = false;
        }
        data.listProduct.map((product, i) => {
          allProducts.push(product);
        });
      });
    }
    const hasProducts = allProducts.length > 0;

    if (customerBanPsidList == null) {
      isAllowSale = false;
    }

    if (isAllowSale == false) {
      props.setError({isDisplay: true, id: 54, isOpenWorkOrder: true});
      return;
    }

    // אם זיהינו שעל הת.ז שהזין יש מוצר תשתית או אם בחר בלקוח חדש וזיהינו שיש מוצר קיים ללקוח (למרות שבחר בלקוח חדש
    if (hasProducts) {
      props.setError({isDisplay: true, id: 54, isOpenWorkOrder: true});
      return;
    }

    //------------------ bezeq ------------------
    if (props.infrastructure.tashtitType == 'BF') {
      //no products
      if (props.productsInfo.bezeqFiberProducts.length == 0) {
        props.setError({isDisplay: true, id: 0, isOpenWorkOrder: false});
        return;
      }

      const selectedProduct = props.productsInfo.selectedProducts[0];
      const equalProduct = props.productsInfo.bezeqFiberProducts.filter((x) => x.downloadSpeed == selectedProduct?.downloadSpeed); //equal product
      const notEqualProducts = props.productsInfo.bezeqFiberProducts.filter((x) => x.downloadSpeed != selectedProduct?.downloadSpeed); //not equal products

      //equal product
      if (equalProduct.length > 0) {
        props.setSelectedInternetPackage(equalProduct[0]); //replace to bezeq product
        props.saveBaseBezeqFiberProduct(equalProduct[0]);
        if (packageType == 'open' && notEqualProducts.length > 0) {
          props.goToPage({page: 'fiberUpgradesPage', percent: 40});
        } else {
          props.goToPage({page: 'technicianPage', percent: 50});
        }
        return;
      } else {
        props.goToPage({page: 'bezeqFiberProductsPage', percent: 40});
        return;
      }
    }
    //------------------ bezeq ------------------

    //לקוח שהגיע לתהליך מבדיקת כתובת, ללא חבילה
    if (packageType == 'none') {
      props.goToPage({page: 'internetPackagesPage', percent: 40});
      return;
    }

    //לקוח שיש אצלו תשתית סלקום+ הגיע לתהליך מחבילה פתוחה ואנחנו רוצים להציע לו לשדרג
    if (packageType == 'open') {
      props.goToPage({page: 'fiberUpgradesPage', percent: 40});
      return;
    }

    props.goToPage({page: 'technicianPage', percent: 50});
  }

  async function getSaleDetails() {
    props.showAppLoader();
    const recaptchaToken = await getRecaptchaToken('OtpVerifyCodePage');
    if (recaptchaToken == undefined || recaptchaToken == null || recaptchaToken == '') {
      return;
    }

    try {
      let res = await ProviderManager.getProviderData('getSaleDetailsOtp', [
        props.saleType,
        props.otpPhone,
        props.otpIdentity,
        props.otpTicketId,
        recaptchaToken,
      ]);
      console.info('getSaleDetailsOtp', res);
      return res?.Body;
    } catch (error) {
      return null;
    } finally {
      props.hideAppLoader();
    }
  }

  async function validateOtp() {
    props.showAppLoader();
    try {
      const result = await ProviderManager.getProviderData('validateOtp', [props.otpPhone, props.otpTicketId, props._otpCode]);

      return result.Header.ReturnCode == 0;
    } catch (error) {
      console.info('validateOtp', error);
      return false;
    } finally {
      props.hideAppLoader();
      props.setIsSubmit({isSubmit: false});
    }
  }

  function handleSubmit(event) {
    event.preventDefault();
  }

  return (
    <div className='slideAnimation'>
      {currentPageHeadline}
      <div className='sale-page-content'>
        <form id='sale' onSubmit={handleSubmit}>
          {' '}
          {currentPageView}{' '}
        </form>
        <SaleFooter
          isDisplayFooter={isDisplayFooter}
          btnText={btnText}
          onclick={currentPageFunction}
          price={totalPrice}
          priceText={priceText}
          formid={formid}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    saleType: state.saleBlock.saleType,
    flowType: state.saleBlock.flowType,
    page: state.saleBlock.page,
    percent: state.saleBlock.percent,
    progressBarPoints: state.saleBlock.progressBarPoints,
    configuration: state.saleBlock.epiServer.configuration,
    totalPrice: state.saleBlock.totalPrice,
    isSubmit: state.saleBlock.isSubmit,
    isValid: state.saleBlock.isValid,
    otpTicketId: state.saleBlock.otpTicketId,
    otpPhone: state.saleBlock.otpPhone,
    otpIdentity: state.saleBlock.otpIdentity,
    wrongOtpMessage: state.saleBlock.wrongOtpMessage,
    numOfAttempts: state.saleBlock.numOfAttempts,
    isUserAddressLoaded: state.saleBlock.isUserAddressLoaded,
    infrastructure: state.saleBlock.selectedAddress.infrastructure,
    productsInfo: state.saleBlock.productsInfo,
    packageType: state.saleBlock.packageType,
    isOtherAddress: state.saleBlock.isOtherAddress,
    isSkipToNewCustomer: state.saleBlock.isSkipToNewCustomer,

    //other states
    _otpCode: state.otpVerifyCode.form.verifyCode,
  };
};

const mapDispatchToProps = {
  goToPage,
  setSaleDetails,
  reportAnalytics,
  setIsSubmit,
  setIsValid,
  setOtpCode,
  setWrongOtpMessage,
  setSelectedInternetPackage,
  saveBaseBezeqFiberProduct,
  addAttempt,
  setError,
  //loader
  showAppLoader,
  hideAppLoader,
};

export default connect(mapStateToProps, mapDispatchToProps)(OtpVerifyCodePage);
